import ExtendedMap from '@/models/ExtendedMap'

import { DTO } from '../DTO'

type Key = res.ClassAssignedTeacher['teacherId']
type Value = res.ClassAssignedTeacher

export class ClassAssignedTeacherColl extends DTO {
  private teachersMap: ExtendedMap<Key, Value>

  constructor(props: res.ClassAssignedTeacher[]) {
    super()
    this.teachersMap = ExtendedMap.fromArr(props, 'teacherId')
  }

  get toArr() {
    return [...this.teachersMap.values()]
  }

  get toKeyArr() {
    return [...this.teachersMap.keys()]
  }

  get(id: Key) {
    return this.teachersMap.get(id)
  }
}
